export const agGridLayoutPolizasDefs = [
    // {
    //     headerName: 'Id',
    //     field: 'id',
    //     editable: false,
    //     width: 80
    // },
    {
        headerName: 'Usuario',
        field: 'usuario',
        editable: false
    },
    {
        headerName: 'Número de Póliza',
        field: 'sl_pol'
    },
    {
        headerName: 'Endoso',
        field: 'sl_end'
    },
    {
        headerName: 'Numero de Cliente',
        field: 'sl_num',
        editable: false
    },
    {
        headerName: 'Nombre del Asegurado',
        field: 'sl_aseg',
        tooltip: (params) => params.value
    },
    {
        headerName: 'Estatus de Póliza',
        field: 'sl_edo',
        editable: false
    },
    {
        headerName: 'Ramo de Póliza',
        field: 'sl_tipo',
        editable: true,
        cellEditor: 'select',
        // tslint:disable-next-line:typedef
        cellEditorParams:  {
        },
        cellRenderer: (data) => {
            return mostrarClave(data);
       }
    },
    {
        headerName: 'Descrpción Original Ramo',
        field: 'ramoorig'
    },
    {
        headerName: 'Inicio Vigencia',
        field: 'sl_vig1',
        cellRenderer: (data) => {
            return fechaEnBlanco(data);
        }
    },
    {
        headerName: 'Fin Vigencia',
        field: 'sl_vig2',
        cellRenderer: (data) => {
            return fechaEnBlanco(data);
        }
    },
    {
        headerName: 'Clave de Compañía',
        field: 'sl_cia'
    },
    {
        headerName: 'Clave de Agente',
        field: 'sl_age',
        editable: true,
        cellEditor: 'select',
        // tslint:disable-next-line:typedef
        cellEditorParams:  {
        },
        cellRenderer: (data) => {
             return mostrarClave(data);
        }
    },
    {
        headerName: 'Descripción Bien Asegurado',
        field: 'sl_obs1'
    },
    {
        headerName: 'Adicionales Bien Asegurado',
        field: 'sl_obs2'
    },
    {
        headerName: 'Observaciones',
        field: 'sl_obs3'
    },
    {
        headerName: 'Observaciones 2',
        field: 'sl_obs4'
    },
    {
        headerName: 'Orden de Trabajo / Solicitud',
        field: 'sl_sol'
    },
    {
        headerName: 'Prima Neta',
        field: 'sl_pri',
        cellRenderer: 'currencyRenderer'
    },
    {
        headerName: 'Descuento Prima Neta',
        field: 'sl_descto',
        cellRenderer: 'currencyRenderer'
    },
    {
        headerName: 'Recargo por Pago Fraccionado',
        field: 'sl_pfra',
        cellRenderer: 'currencyRenderer'
    },
    {
        headerName: 'Derechos de Expedición de Póliza',
        field: 'sl_derp',
        cellRenderer: 'currencyRenderer'
    },
    {
        headerName: 'Iva',
        field: 'sl_iva',
        cellRenderer: 'currencyRenderer',
        cellEditor: 'numericEditor'
    },
    {
        headerName: 'Comisión',
        field: 'sl_com',
        cellRenderer: 'currencyRenderer'
    },
    {
        headerName: 'Importe Primera Parcialidad Póliza',
        field: 'sl_1erp',
        cellRenderer: 'currencyRenderer'
    },
    {
        headerName: 'Importe de Pagos Subsecuentes de Póliza',
        field: 'sl_sigp',
        cellRenderer: 'currencyRenderer'
    },
    {
        headerName: 'Fecha de Emisión de Póliza',
        field: 'sl_fpol',
        cellRenderer: (data) => {
            return fechaEnBlanco(data);
        }
    },
    {
        headerName: 'Forma de Pago',
        field: 'sl_fpa'
    },
    {
        headerName: 'Fecha de Renovación',
        field: 'sl_fren',
        cellRenderer: (data) => {
            return fechaEnBlanco(data);
        }
    },
    {
        headerName: 'Número Póliza anterior',
        field: 'sl_pola'
    },
    {
        headerName: 'Póliza Renovación',
        field: 'sl_renov'
    },
    {
        headerName: 'Clave de Grupo',
        field: 'sl_gpo'
    },
    {
        headerName: 'Capturista de Póliza',
        field: 'sl_cap'
    },
    {
        headerName: 'Plan/Producto/Cobertura',
        field: 'sl_cob',
        editable: true,
        cellEditor: 'select',
        // tslint:disable-next-line:typedef
        cellEditorParams:  {
        },
        cellRenderer: (data) => {
            return mostrarClave(data);
       }
    },
    {
        headerName: 'Cobertura Original',
        field: 'coborig'
    },
    {
        headerName: 'Codigo Cliente',
        field: 'sl_codclt'
    },
    {
        headerName: 'Vía de Pago',
        field: 'sl_vpag',
        editable: true,
        cellEditor: 'select',
        cellEditorParams: {
        //   values: ['', 'ELECTRÓNICA', 'AGENTE']
        },
        cellRenderer: (data) => {
            return mostrarClaveViaPago(data);
       }

    },
    {
        headerName: 'Descripción Via de Pago',
        field: 'sl_desvp'
    },
    {
        headerName: 'Moneda',
        field: 'sl_mon'
    },
    {
        headerName: 'Fecha de Alta en Compañía',
        field: 'sl_falta',
        cellRenderer: (data) => {
            return fechaEnBlanco(data);
        }
    },
    {
        headerName: 'Contrato de Póliza de Flotilla',
        field: 'sl_contrato'
    },
    {
        headerName: 'Caratula de Póliza',
        field: 'sl_caratula'
    },
    {
        headerName: 'Domicilio del Asegurado',
        field: 'sl_dom'
    },
    {
        headerName: 'Nombre del Asegurado',
        field: 'cl_nombre'
    },
    {
        headerName: 'Colonia del Asegurado',
        field: 'cl_col'
    },
    {
        headerName: 'Población del Asegurado',
        field: 'cl_pob'
    },
    {
        headerName: 'Teléfono Casa Asegurado',
        field: 'cl_telc'
    },
    {
        headerName: 'Fecha de Nacimiento del Asegurado',
        field: 'cl_fnac'
    },
    {
        headerName: 'Rfc del Asegurado',
        field: 'cl_rfc'
    },
    {
        headerName: 'CP del Asegurado',
        field: 'cl_cp'
    },
    {
        headerName: 'Consecutivo de Incisos',
        field: 'in_num'
    },
    {
        headerName: 'Número de Serie del Vehículo',
        field: 'in_llave'
    },
    {
        headerName: 'Descripción Bien Asegurado',
        field: 'in_dato1'
    },
    {
        headerName: 'Tipo de Bien Asegurado',
        field: 'in_tipo'
    },
    {
        headerName: 'Inf. del Bien Asegurado',
        field: 'in_dato4'
    },
    {
        headerName: 'Inf. del Bien Asegurado',
        field: 'in_dato5'
    },
    {
        headerName: 'Inf. del Bien Asegurado',
        field: 'in_dato6'
    },
    {
        headerName: 'Valor Referencial del Bien Asegurado',
        field: 'in_numero1'
    },
    {
        headerName: 'Fecha Referencial del Bien Asegurado',
        field: 'in_fecha1',
        cellRenderer: (data) => {
            return fechaEnBlanco(data);
        }
    },
    {
        headerName: 'Importe Referencial del Bien Asegurado',
        field: 'in_imp1'
    },
    {
        headerName: 'Fecha 2 Referencia del Bien Asegurado',
        field: 'in_fecha2',
        cellRenderer: (data) => {
            return fechaEnBlanco(data);
        }
    },
    {
        headerName: 'Prima Total de la Póliza',
        field: 'sl_primtot',
        cellRenderer: 'currencyRenderer'
    },
    {
        headerName: 'Nombre del Archivo Procesado',
        field: 'archivo',
        editable: false
    },
    {
        headerName: 'Errores en proceso',
        field: 'error',
        width: 200,
        hide: true,
        editable: false,
        tooltip: (params) => params.value
    }
];

export const agGridCapturaPolizasDefs = [
    {
        headerName: 'Estatus',
        field: 'sl_edo',
        checkboxSelection: true,
        headerCheckboxSelection: false,
        headerCheckboxSelectionFilteredOnly: false,
        width: 120
    },
    {
        headerName: 'Ent.',
        field: 'ent_sino',
        width: 100
    },
    {
        headerName: 'Rec Orig.',
        field: 'orig_comp',
        cellRenderer: (data) => {
            return formatoFecha(data);
        },
        width: 100
    },
    {
        headerName: 'Cve.',
        field: 'sl_age'
    },
    {
        headerName: 'OT / Folio',
        field: 'sl_sol'
    },
    {
        headerName: 'Cia.',
        field: 'sl_cia'
    },
    {
        headerName: 'Póliza',
        field: 'sl_pol'
    },
    {
        headerName: 'Poliza Ant.',
        field: 'sl_pola'
    },
    {
        headerName: 'Inicio Vigencia',
        field: 'sl_vig1'
    },
    {
        headerName: 'Asegurado',
        field: 'sl_aseg',
        width: 500
    },
    {
        headerName: 'Fin Vig.',
        field: 'sl_vig2'
    },
    {
        headerName: 'Ramo',
        field: 'sl_tipo'
    },
    {
        headerName: 'Prima Neta',
        field: 'sl_pri',
        cellRenderer: CurrencyCellRendererMXN
    },
    {
        headerName: 'FP',
        field: 'sl_fpa'
    },
    {
        headerName: 'Emision',
        field: 'sl_fpol'
    },
    {
        headerName: 'Contrato',
        field: 'sl_contrato'
    },
    {
        headerName: 'Observaciones',
        field: 'sl_obs1'
    },
    {
        headerName: '',
        field: 'sl_nren'
    }
];

export const agGridCapturaPolizasUnidadesDefs = [
    {
        headerName: 'Selección',
        width: 120,
        checkboxSelection: true,
        pinned: 'left',
        resizable: false,
        sortable: false,
        filter: false,
        editable: false
    },
    {
        headerName: 'Vehiculo',
        field: 'in_dato1',
        width: 100
    },
    {
        headerName: 'Placas',
        field: 'in_dato4'
    },
    {
        headerName: 'Modelo',
        field: 'in_numero1'
    },
    {
        headerName: 'Motor',
        field: 'in_dato6'
    },
    {
        headerName: 'Clave',
        field: 'in_dato5'
    },
    {
        headerName: 'Suma Asegurada',
        field: 'in_imp1'
    }
];

export const agGridCapturaPolizasAseguradosDefs = [
    {
        headerName: 'Selección',
        width: 120,
        checkboxSelection: true,
        pinned: 'left',
        resizable: false,
        sortable: false,
        filter: false,
        editable: false
    },
    {
        headerName: 'RFC/CURP',
        field: 'in_llave'
    },
    {
        headerName: 'Nombre',
        field: 'in_dato1'
    },
    {
        headerName: 'Alta',
        field: 'in_fecha2'
    },
    {
        headerName: 'Nacimiento',
        field: 'in_fecha1'
    },
    {
        headerName: 'Puesto / Parentesco',
        field: 'in_dato5'
    }
];



export const agGridCapturaPolizasUbicacionesDefs = [
    {
        headerName: 'Selección',
        width: 120,
        checkboxSelection: true,
        pinned: 'left',
        resizable: false,
        sortable: false,
        filter: false,
        editable: false
    },
    {
        headerName: 'Ubicación / Sucursal',
        field: 'in_llave'
    },
    {
        headerName: 'Dirección',
        field: 'in_dato1'
    },
    {
        headerName: 'Municipio',
        field: 'in_dato2'
    },
    {
        headerName: 'Estado',
        field: 'in_dato3'
    }
];


function formatoFecha(data): any {
    const fecha = new Date(data.value);
    const month = (fecha.getMonth() + 1) < 10 ? '0' + (fecha.getMonth() + 1) : (fecha.getMonth() + 1);
    const day = fecha.getDate() < 9 ? '0' + fecha.getDate() : (fecha.getDate() + 1);
    return data.value ? fecha.getFullYear() + '-' + month + '-' + day : '';
}

function fechaEnBlanco(data): any {
    const fecha = data.value;
    if (fecha === '0000-00-00') {
        return '';
    } else {
        return fecha;
    }
}

function mostrarClave(data): any {
    const clave = data.value.split(' - ');
    if (clave.length > 1) {
        return clave[0];
    } else {
        return data.value;
    }
}

function mostrarClaveViaPago(data): any {
    if (data.value === 'ELECTRÓNICA') {
        return 'E';
    } else if (data.value === 'AGENTE') {
        return 'A';
    } else{
        return data.value;
    }
}

function CurrencyCellRendererMXN(params: any) {
    var inrFormat = new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: 2
    });
    return inrFormat.format(params.value);
}





